import React, { useState, useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditLevel6(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [level6, setLevel6] = React.useState({
    description: props.product.description ? props.product.description : "",
    usageWay: props.product.usageWay ? props.product.usageWay : "",
    sumDescription: props.product.sumDescription
      ? props.product.sumDescription
      : "",
    metaDescription: props.product.metaDescription
      ? props.product.metaDescription
      : "",
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.fire) {
      Validation6();
    }
  }, [props.fire]);

  return (
    <Accordion
      expanded={props.expanded === "panel6"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        onClick={() => props.setExpanded("panel6")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography>مرحله ششم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از اتمام ویرایش محصول اطمینان دارید ؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => props.setFire(true)}
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setOpen(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Typography color="secondary" sx={{ mb: 1, fontWeight: "bold" }}>
              توضیحات :
            </Typography>

            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              style={{ p: "100px", width: "100%" }}
              data={level6.description ? level6.description : ""}
              onChange={(event, editor) => {
                const data = editor.getData();

                setLevel6({ ...level6, description: data });
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "250px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Typography color="secondary" sx={{ mb: 1, fontWeight: "bold" }}>
              روش مصرف :
            </Typography>

            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              style={{ p: "100px", width: "100%" }}
              data={level6.usageWay ? level6.usageWay : ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                setLevel6({ ...level6, usageWay: data });
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "250px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{ height: "100%" }}
          >
            <Typography color="secondary" sx={{ mb: 1, fontWeight: "bold" }}>
              توضیحات متا:
            </Typography>
            <TextField
              fullWidth
              value={level6.metaDescription}
              multiline
              rows={10.9}
              onChange={(evt) => {
                if (evt.target.value.length < 151) {
                  setLevel6({ ...level6, metaDescription: evt.target.value });
                  return;
                } else {
                  setLevel6({
                    ...level6,
                    metaDescription: level6.metaDescription,
                  });
                  enqueueSnackbar("بیشتر از مقدار مجاز (150 کاراکتر)", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
              }}
              size="small"
              variant="outlined"
            />

            {/* <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              style={{ p: "100px", width: "100%" }}
              data={level6.metaDescription || ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                var text = data
                  .replace(/<("[^"]*"|'[^']*'|[^'">])*>/gi, "")
                  .replace(/^\s+|\s+$/g, "");
                if (text.length < 151) {
                  setLevel6({ ...level6, metaDescription: data });
                  return;
                } else {
                  enqueueSnackbar("بیشتر از مقدار مجاز (150 کاراکتر)", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "250px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            /> */}
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Typography color="secondary" sx={{ mb: 1, fontWeight: "bold" }}>
              توضیحات اختصاری:
            </Typography>

            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              style={{ p: "100px", width: "100%" }}
              data={level6.sumDescription ? level6.sumDescription : ""}
              onChange={(event, editor) => {
                const data = editor.getData();

                setLevel6({ ...level6, sumDescription: data });
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "250px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                props.setExpanded("panel5");
              }}
            >
              مرحله قبل
            </Button>
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              onClick={() => setOpen(true)}
            >
              اتمام
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => Validation6()}
            >
              مرحله بعد
            </Button>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  function Validation6() {
    if (props.fire == false) {
      enqueueSnackbar("مرحله ششم با موفقیت تکمیل شد", {
        variant: "success",
        autoHideDuration: 2000,
      });
      props.setExpanded("panel7");
    }
    props.fill(level6);
  }
}
